import {
  IPractice,
  IPracticeSetupStep,
  IPracticeSetupWizard,
  IStaffer,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { INamedDocument, Region, WithRef } from '@principle-theorem/shared';
import {
  MockDocRef,
  MockNamedDocument,
  MockWithRef,
} from '@principle-theorem/testing';
import { PracticeSetupStep } from './practice-setup-step';
import { PracticeSetupWizard } from './practice-setup-wizard';

const mockPracticePath = 'brands/brand1/practices/practice1';
const mockWizardPath = `${mockPracticePath}/setupWizard/wizard1`;
const mockPracticeRef = MockDocRef<IPractice>(mockPracticePath);

export function MockPracticeSetupWizard(
  overrides: Partial<IPracticeSetupWizard> = {}
): WithRef<IPracticeSetupWizard> {
  return MockWithRef(
    {
      ...PracticeSetupWizard.init({ practiceRef: mockPracticeRef }),
      ...overrides,
    },
    mockWizardPath
  );
}

export function MockAllSetupSteps(
  overrides?: Partial<Record<PracticeSetupStepId, Partial<IPracticeSetupStep>>>,
  region = Region.Australia
): WithRef<IPracticeSetupStep>[] {
  return PracticeSetupWizard.getRegionFilteredSteps(region).map(
    (definition) => {
      const stepOverrides = overrides?.[definition.id] ?? {};

      return MockWithRef(
        PracticeSetupStep.init({ ...definition, ...stepOverrides }),
        `${mockWizardPath}/steps/${definition.id}`
      );
    }
  );
}

export function MockSetupStepAssignment(
  overrides: Partial<INamedDocument<IStaffer>> = {}
): INamedDocument<IStaffer> {
  return {
    ...MockNamedDocument<IStaffer>('John Doe', 'brands/brand1/staff/staff1'),
    ...overrides,
  };
}
